<div class="guts-p-b-1">
  <div class="box m-guts-p-t-1-half guts-p-b-2" [class.m-guts-p-b-0]="!isEmpty">
    <div
      class="guts-p-h-2 guts-p-t-2 m-guts-p-t-0 guts-m-b-quart"
    >
      <h3 class="h3">
        {{ 'dgProfileOverview_TooltipSignalsPlural' | translate }}
      </h3>
      <h4 class="par par--small par--light_a">
        {{ 'dgSkillSignal_BarChartSubheading' | translate }}
      </h4>
    </div>
    <!-- Empty State Bar -->
    <div
      *ngIf="isEmpty"
      class="activity-bar-empty"
      [ngStyle]="{'top': isMobile ? '62px' : '33px'}"
    ></div>
    <!-- Bar Chart -->
    <div id="signal-bar-chart" class="signal-bar-chart guts-p-h-1-half"></div>
  </div>
</div>
